const COSTA_RICA_WEEKDAY = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Costa_Rica',
  weekday: 'long',
});

/** Indica si el instante dado corresponde a un lunes en Costa Rica. */
export function isMondayInCostaRica(value: string | Date): boolean {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  return COSTA_RICA_WEEKDAY.format(date) === 'Monday';
}
